import BaseOnboarding from 'onboarding/onboardings/baseonboarding';
import ProjectsListDetailInfoOnboarding from 'onboarding/onboardings/ProjectsListDetailInfoOnboarding/projectsListDetailInfoOnboarding';

import WhatIsProjectStep from 'onboarding/onboardings/ProjectsListCommonInfoOnboarding/steps/WhatIsProjectStep';
import GroupingCampaignsStep from 'onboarding/onboardings/ProjectsListCommonInfoOnboarding/steps/GroupingCampaignsStep';
import onboardingManager from 'onboarding/onboardingmanager';

import store from 'store';
import AppEventBus from 'utils/appEventBus';
import nextFrame from 'utils/nextFrame';


class ProjectsListCommonInfoOnboarding extends BaseOnboarding {
  static get name () {
    return 'projects-list-onboarding';
  }

  static get trackingName () {
    return 'onboarding_projects_series_1';
  }

  steps () {
    return [
      {
        target: '#page-layout-sidebar .bottom-menu .help-icon-wrapper',
        attachToHighlight: false,
        header: 'Что такое проект',
        component: WhatIsProjectStep,
        params: {
          customArrowStyle: {opacity: 0},
          placement: 'bottom',
          enableScrolling: true
        },
        events: {
          on () {
            window.ymReachGoal('ONBOARDING_PROJECTS_START');
          }
        },
        width: '408px',
        highlightTarget: '#page-layout-sidebar .bottom-menu .help-icon-wrapper',
        highlightOptions: {
          shape: 'circle',
          maskBorder: 0,
          maskSizeOffsetX: 0,
          maskSizeOffsetY: 0
        }
      },
      {
        target: '#page-layout-sidebar .bottom-menu .help-icon-wrapper',
        attachToHighlight: false,
        header: 'Как группировать кампании в проектах',
        component: GroupingCampaignsStep,
        params: {
          customArrowStyle: {opacity: 0},
          placement: 'bottom',
          enableScrolling: true
        },
        width: '418px',
        highlightTarget: '#page-layout-sidebar .bottom-menu .help-icon-wrapper',
        highlightOptions: {
          shape: 'circle',
          maskBorder: 0,
          maskSizeOffsetX: 0,
          maskSizeOffsetY: 0
        }
      },
      {
        target: '.sidebar-account-node__active-wrapper .sidebar-tree-node-dropdown__active',
        attachToHighlight: true,
        header: 'Кликните на проект в боковом меню, чтобы изучить как он устроен, или создайте проект, если его еще нет',
        params: {
          placement: 'right',
          enableScrolling: true
        },
        width: '408px',
        highlightTarget: '.sidebar-account-node__active-wrapper .sidebar-tree-node-dropdown__active',
        highlightOptions: {
          shape: 'square',
          maskBorder: 4,
          maskSizeOffsetX: 0,
          maskSizeOffsetY: 4,
          allowClickInside: true,
          overflowBoundariesEl: '#page-layout-sidebar .middle-content'
        },
        hideFinishButton: true,
        events: {
          on: (mTourCtx) => {
            store.dispatch('routing/RESET_INSTRUMENT_ROUTES');

            document.getElementById('page-layout').addEventListener('click', () => {
              // trigger finish callback to mark onboarding as finished
              mTourCtx.callbacks.onStop();
            }, {once: true});

            // run next onboarding step after route changed
            AppEventBus.$once('ROUTE_NAVIGATION_COMPLETE', () => {

              // to prevent errors when the onboarding can't find the target
              AppEventBus.$once('PROJECT_DASHBOARD_FETCHED', () => {
                nextFrame(() => {
                  onboardingManager.scheduleOnboarding(ProjectsListDetailInfoOnboarding, this.trackingParams);
                });
              });
            });
          }
        }
      }
    ];
  }
}

export default ProjectsListCommonInfoOnboarding;
